import React, { useCallback, useMemo } from 'react';
import { getColumns } from './columns';
import VirtualTable from 'components/VirtualTable/VirtualTable';
import { Button, Modal, Table } from 'semantic-ui-react';

export default function MarketplacePendingOrdersTable({
  loading,
  orders,
  lastResetSelectedRows,
  hasNextPage,
  onRowSelect = () => {},
  onLoadMoreItems = () => {},
}) {
  const renderActions = useCallback((row) => {
    return (
      <>
        <Modal
          centered={false}
          trigger={<Button circular icon="list" />}
          header="Líneas"
          content={
            <div style={{ padding: 20 }}>
              <Table celled striped>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Artículo</Table.HeaderCell>
                    <Table.HeaderCell>ASIN</Table.HeaderCell>
                    <Table.HeaderCell>Cantidad</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {row?.lines?.map((line, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{line?.article}</Table.Cell>
                      <Table.Cell>{line?.asin}</Table.Cell>
                      <Table.Cell>{line?.quantity || '-'}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          }
          actions={[
            {
              key: 'close',
              content: 'Cerrar',
            },
          ]}
        />
      </>
    );
  }, []);

  const columns = useMemo(() => getColumns(renderActions), [renderActions]);

  return (
    <VirtualTable
      loading={loading}
      columns={columns}
      data={orders}
      selectable
      hasNextPage={hasNextPage}
      lastResetSelectedRows={lastResetSelectedRows}
      onLoadMoreItems={onLoadMoreItems}
      onRowSelect={onRowSelect}
    />
  );
}
